module.exports = __webpack_public_path__ + "img/stackslash-6-mobile.0898b013.jpg";